<!-- @format -->

<help-tag>
  <div is="{state.tag}"></div>
<script>
  import di from "dependency-injection";
  import index from "@tags/pages/menu/help/index.riot";
  import about from "@tags/pages/menu/help/about.riot";
  import progress from "@tags/pages/menu/help/progress.riot";
  import money from "@tags/pages/menu/help/money.riot";
  import flowBusiness from "@tags/pages/menu/help/flow/business.riot";
  import flowMoney from "@tags/pages/menu/help/flow/money.riot";

  export default {
    state: {
      tag: "index"
    },
    components: {
      "index": index,
      "about": about,
      "progress": progress,
      "money": money,
      "flow-business": flowBusiness,
      "flow-money": flowMoney
    },
    onBeforeMount(props){
      const big_category = props.routeParams[0] || null;
      const small_category = props.routeParams[1] || null;
      if (!small_category) {
        this.state.tag = this.components[big_category] ? big_category : 'index';
      }else{
        this.state.tag = this.components[`${big_category}-${small_category}`] ? `${big_category}-${small_category}`: 'index';
      }
    }
  }
</script>
</help-tag>
